"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classNames = void 0;
// tslint:disable-next-line:no-var-requires
var realClassNames = require('classnames');
var classNames = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return realClassNames.apply(void 0, classes);
};
exports.classNames = classNames;
//# sourceMappingURL=classnames.js.map